export const commonConfig = {
  darkTheme: false,
  classicHeader: true,
};
